import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, Title } from '../../../styles/index.sty';
import AlertSnack from '../../../components/Alert/AlertSnack'
import { useAuth } from '../../../context/authContext'
import { useLists } from '../../../context/listContext'
import { insertColorData, updateColorData } from '../../../api/attributes.api'

export const AddColor = () => {
  const { config } = useAuth();
  const { fetchColorsList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const formik = useFormik({
    initialValues: {
    color_name: location?.state?.data?.color_name,
    color_hex: location?.state?.data?.color_hex || "#000000"
    },
    onSubmit: async values => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateColorData({...values, product_color_id: location?.state?.data?.product_color_id }, config);
        setResponse(submit);
        setOpen(true);
        fetchColorsList();
        if(submit.status === "success") {
          navigate("/colors");
        }
      } else {
        const submit = await insertColorData(values, config);
        setResponse(submit);
        fetchColorsList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/colors");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Color Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="color_name">Color Name:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="color_name"
            placeholder="Enter Color Name"
            id="color_name"
            type="text"
            value={formik.values.color_name}
            onChange={formik.handleChange}
            />
        </FormGroup><br/>
        <FormGroup>
          <InputLabel htmlFor="color_hex">Color Hex:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="color_hex"
            placeholder="Enter Color Hex"
            id="color_hex"
            type="color"
            value={formik.values.color_hex}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/colors")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
};
